import { cancel, put, select, takeEvery } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  PreiseStreckeErmittelt,
} from '@ps20-frontend/shop-integration-redux';
import { App, Produktlinie, ZuersZoneEnum } from '@ps20-frontend/frontend-models';
import { Produktlinienname } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { isHoechsteZuersZone } from '../../app/shared/selectors/produkt.selector';
import { IAppState } from '../appState';
import { ZusatzoptionenNameVHVEnum } from '../model/zusatzoptionenVHV.model';
import { VhvActions } from '../vhvActions';
import { VersicherungsSummeGrenzen } from '../model/versicherungssummen';
import {
  activateProduktlinie,
  deactivateProduktlinie,
  resetToDefaultProduktlinieIfNecessary,
} from './produktlinienSaga';

//TODO: Fast identisch zur Saga in VWG
export function* extremWetterSchutzVorbelegenSaga() {
  yield takeEvery(
    GlobalActions.PREISE_STRECKE_ERMITTELT,
    safeSaga(handleProduklinienAnpassungen, App.VHV),
  );
}

export function* handleProduklinienAnpassungen(action: GlobalAction<PreiseStreckeErmittelt>) {
  const state: IAppState = yield select();
  if (
    action.payload.appId !== App.VHV ||
    action.payload.angebotsId !== state.angebotsId ||
    state.vertragsoptionen?.beibehalten
  ) {
    yield cancel();
  }

  let produktlinien = state.produkt.produktlinien;
  const zuerszone = state.elementarSelbstbehalt.id;
  const staendigBewohnt: boolean = state.versObjekt.staendigBewohnt;
  const versicherungssummeLinieXL = state.versicherungssummen.find(
    versicherungssumme => versicherungssumme.produktlinie === Produktlinienname.PREMIUM,
  );
  let zusatzOptionenChanged = false;
  [produktlinien, zusatzOptionenChanged] = extremWetterSchutzVorbelegen(state, produktlinien);

  if (zuerszone === ZuersZoneEnum.VIER && !state.vorbelegungen?.activateElementar) {
    deactivateProduktlinie(produktlinien, Produktlinienname.PREMIUM);
    resetToDefaultProduktlinieIfNecessary(produktlinien);
    yield put(new VhvActions().produktlinienChanged(produktlinien));
  } else if (
    versicherungssummeLinieXL.summe <= VersicherungsSummeGrenzen.MAX_VERSSUMME &&
    staendigBewohnt
  ) {
    activateProduktlinie(produktlinien, Produktlinienname.PREMIUM);
    yield put(new VhvActions().produktlinienChanged(produktlinien));
  }

  if (zusatzOptionenChanged) {
    yield put(new VhvActions().requestPreis());
  }
}

export function extremWetterSchutzVorbelegen(
  state: IAppState,
  produktlinien: Array<Produktlinie>,
): [Array<Produktlinie>, boolean] {
  const extremwetterDisabled = isHoechsteZuersZone(state);
  const selectedProduktlinie = produktlinien.find(produktlinie => produktlinie.selected);

  if (selectedProduktlinie == undefined) {
    return [produktlinien, false];
  }

  const extremWetterSchutzZusatzoption = selectedProduktlinie.zusatzoptionen.find(
    zusatzoption => zusatzoption.name == ZusatzoptionenNameVHVEnum.ELEMENTAR,
  );
  if (
    extremWetterSchutzZusatzoption.disabled != undefined &&
    extremwetterDisabled == extremWetterSchutzZusatzoption.disabled
  ) {
    return [produktlinien, false];
  }

  if (!extremwetterDisabled && !extremWetterSchutzZusatzoption.isSelected) {
    const newProduktLinien = produktlinien.map(produktlinie => {
      produktlinie.zusatzoptionen = produktlinie.zusatzoptionen.map(zusatzoption => {
        if (zusatzoption.name === ZusatzoptionenNameVHVEnum.ELEMENTAR) {
          return { ...zusatzoption, isSelected: true, disabled: false };
        }
        return zusatzoption;
      });
      return produktlinie;
    });
    return [newProduktLinien, true];
  }

  if (extremwetterDisabled) {
    const newProduktLinien = produktlinien.map(produktlinie => {
      produktlinie.zusatzoptionen = produktlinie.zusatzoptionen.map(zusatzoption => {
        if (zusatzoption.name === ZusatzoptionenNameVHVEnum.ELEMENTAR) {
          return { ...zusatzoption, disabled: true, isSelected: false };
        }
        return zusatzoption;
      });
      return produktlinie;
    });
    return [newProduktLinien, true];
  }

  return [produktlinien, false];
}
